import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { AppComponent } from '../../app.component';
import { MessagesService } from '@core/_services/messages.service';
import {
    AvailableTheme,
    defaultPage,
    AvailableMenuStyle,
    defStatStyle,
    defStatPer,
    AvailableStatStyle,
    AvailableStatPer,
    defBskLoadMax,
    defReqLoadMax,
    AvailableScale,
    AvailableBskLoadMax,
    AvailableReqLoadMax,
    MenuStyle,
    AvailableMenuThemes,
    AvailableTopBarThemes,
    defaultModeView,
    AvailableModeView,
    reqBsk,
    reqWds,
    reqTre,
    reqIdx, AvailableInputStyle, 
    InputStyle,
    AvailableBskTabDetail,
    AvailableSrcTabDetail,
    defaultModeViewDoc,

} from '@documalis/_const/const';
import { PreferData, convertStringToBoolean, storeData, setUpdatePref, getPageFromType} from '@core/_utils/tools.utils';
import { AuthService } from '@auth/auth.service';
import { CommonService } from '@service/common.service';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { ConfirmationService } from 'primeng/api';
import { CheckTools } from '@service/check.tools';
import { RequestTools } from '@service/request.tools';
import { TranslateService } from '@ngx-translate/core';
import { addRequestParam, getLabelOfTypePref, getPageList, setInformations, setPref, updateRequestParam } from '@core/_utils/param-screen-utils';
import { LayoutService, MenuMode } from '../../layout/service/app.layout.service';
import { AppConfigComponent } from '../../layout/config/app.config.component';

@Component({
    selector: 'app-preference',
    templateUrl: './preference.component.html',
    styleUrls: ['./preference.component.scss'],
})
export class PreferenceComponent implements OnInit {
    public fr: any;
    public requests = [];
    public availablePageList: any[];
    public availableThemeList: any[];
    public availableMenuList: any[];
    public availableStatStyle: any[];
    public availableStatPer: any[];
    public availableBskLoadMax: any[];
    public availableReqLoadMax: any[];
    public availableMenuThemeList: any [];
    public availableTopBarThemeList: any [];
    public availableScale: any [];
    public availableModeView: any[];
    public availableBskTabDetail: any[];
    public availableSrcTabDetail: any[];
    public selectedPage = '';
    public selectedTheme = '';
    public browseLabel = '';
    public fileMsg = '';
    public itemConfirm: ItemConfirmComponent;

    public screen: PreferData;
    public theme: PreferData;
    public emptyBsk: PreferData;
    public menuTheme: PreferData;
    public topBarTheme: PreferData;
    public styleMenu: PreferData;
    public styleInput: PreferData;
    public gradBsk: PreferData;
    public statNbDoc: PreferData;
    public statStyle: PreferData;
    public statPer: PreferData;
    public bskLoadMax: PreferData;
    public reqLoadMax: PreferData;
    public bskNextVal: PreferData;
    public scale: PreferData;
    public modeView: PreferData;
    public statOldDoc: PreferData;
    public statLoad: PreferData;
    public statView: PreferData;
    public statWork: PreferData;
    public lastReq: PreferData;
    public modeViewDoc: PreferData;    
    public defaultFullTextDate: PreferData;
    public bskCompact: PreferData;
    public bskTabDetail: PreferData;
    public srcTabDetail: PreferData;

    public emptyBskBool: boolean;
    public gradBskBool: boolean;
    public statNbDocBool: boolean;
    public bskNextValBool: boolean;
    public statOldDocBool: boolean;
    public statLoadBool: boolean;
    public statViewBool: boolean;
    public statWorkBool: boolean;
    public lastReqBool: boolean;
    public version: string = '';
    public isAdmin = false;
    private currentPref: any;
    private internalPrefUsr: any;
    public availableInputStyle: any;
    public bskCompactBool: boolean;

    constructor(
        public layoutService: LayoutService, 
        public menu: MenuServiceInt,
        public main: AppComponent,
        protected _messageService: MessagesService,
        private auth: AuthService,
        private commonService: CommonService,
        public confirmationService: ConfirmationService,
        private checkTools: CheckTools,
        private requestTools: RequestTools,
        private translate: TranslateService,
        private appConfig: AppConfigComponent
    ) {
        this.menu.display = true;
        this.availablePageList = [];
        this.availableThemeList = [];
        this.availableMenuList = [];
        this.availableStatStyle = [];
        this.availableStatPer = [];
        this.availableBskLoadMax = [];
        this.availableReqLoadMax = [];        
        this.availableMenuThemeList = [];
        this.availableTopBarThemeList = [];
        this.availableScale = [];
        this.availableModeView= [];
        this.availableBskTabDetail = [];
        this.availableSrcTabDetail = [];
        this.isAdmin = this.auth.isAdmin();
        this.internalPrefUsr = {};
        this.browseLabel = this.translate.instant('Img_Sel');
        this.fileMsg = this.translate.instant('FileType_KO');
    }

    ngOnInit() {
        this.initializeValDef();
        this.execGetPref(true);
        this.setDefPref();
        this.commonService.checkReset();
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
    }

    public ngOnDestroy() {}

    private async execGetPref(aLoad) {
        let wRes;
        wRes = false;     
        this.screen = setPref(0, defaultPage);
        this.theme = setPref(0, this.layoutService.config().componentTheme);
        this.topBarTheme = setPref(0, this.layoutService.config().topbarTheme);
        this.emptyBsk = setPref(0, 'false');
        this.menuTheme = setPref(0, this.layoutService.config().menuTheme);
        this.styleMenu = setPref(0,  MenuStyle.indexOf(this.layoutService.config().menuMode));
        this.styleInput = setPref(0, InputStyle.indexOf(this.layoutService.config().inputStyle));
        this.gradBsk = setPref(0, 'true');
        this.statNbDoc = setPref(0, 'false');
        this.statStyle = setPref(0, defStatStyle);
        this.statPer = setPref(0, defStatPer);
        this.bskLoadMax = setPref(0, defBskLoadMax);
        this.reqLoadMax = setPref(0, defReqLoadMax);        
        this.bskNextVal = setPref(0, 'false');
        this.statOldDoc = setPref(0, 'true');
        this.lastReq = setPref(0, 'true');
        this.statLoad = setPref(0, 'true');
        this.statView = setPref(0, 'true');
        this.statWork = setPref(0, 'true');
        this.bskCompact = setPref(0, 'false');
        this.emptyBskBool = convertStringToBoolean(this.emptyBsk.datapref);
        this.gradBskBool = convertStringToBoolean(this.gradBsk.datapref);
        this.statNbDocBool = convertStringToBoolean(this.statNbDoc.datapref);
        this.bskNextValBool = convertStringToBoolean(this.bskNextVal.datapref);
        this.statOldDocBool = convertStringToBoolean(this.statOldDoc.datapref);
        this.lastReqBool = convertStringToBoolean(this.lastReq.datapref);
        this.statLoadBool = convertStringToBoolean(this.statLoad.datapref);
        this.statViewBool = convertStringToBoolean(this.statView.datapref);
        this.statWorkBool = convertStringToBoolean(this.statWork.datapref);
        this.scale = setPref(0, 14);
        this.modeView = setPref(0, defaultModeView);        
        this.bskCompactBool = convertStringToBoolean(this.bskCompact.datapref);
        this.bskTabDetail = setPref(0, 'Read_Pdf');
        this.srcTabDetail = setPref(0, 'Read_Pdf');

        wRes = await this.requestTools.getUserPrefer();
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            return;
        }
        wRes.data.getUserPref.data.map((item) => {
            this.affectValue(item);
        });
        this.currentPref = {
            theme: this.theme.datapref,
            menuTheme: this.menuTheme.datapref,
            menuStyle: this.styleMenu.datapref,
            inputStyle: this.styleInput.datapref,
            topBarTheme: this.topBarTheme.datapref,
            scale: this.scale.datapref,
        };                
        storeData('preference', JSON.stringify(this.currentPref));
        this.version = setInformations(wRes.data.getInformations);
    }

    private setDefPref() {
        this.availableStatStyle = [];
        this.availableModeView = [];
        this.availableStatPer = [];
        this.availableBskLoadMax = [];
        this.availableBskTabDetail = [];
        this.availableSrcTabDetail = [];
        this.availablePageList = getPageList(this.translate);
        this.availableThemeList = AvailableTheme;
        this.availableMenuThemeList = AvailableMenuThemes;
        this.availableTopBarThemeList = AvailableTopBarThemes;
        this.emptyBskBool = false;
        this.gradBskBool = true;
        this.statNbDocBool = false;
        this.bskNextValBool = false;
        this.availableMenuList = AvailableMenuStyle;
        this.availableInputStyle = AvailableInputStyle;
        AvailableStatStyle.forEach(item => {            
            this.availableStatStyle.push({ label: this.translate.instant(item.value), value: item.value});
        });  
        AvailableStatPer.forEach(item => {
            this.availableStatPer.push({ label: this.translate.instant(item.value), value: item.value});
        });       
        AvailableBskLoadMax.forEach(item => {
            this.availableBskLoadMax.push({ label: this.translate.instant(item.value), value: item.value});
        });

        this.availableReqLoadMax = AvailableReqLoadMax;        
        this.availableScale = AvailableScale;
        AvailableModeView.forEach(item => {
            this.availableModeView.push({ label: this.translate.instant(item.value), value: item.value});            
        });

        //  61 : Visualisation mode détail bannette
        AvailableBskTabDetail.forEach(item => {
            this.availableBskTabDetail.push({ label: this.translate.instant(item.value), value: item.value});            
        });
            
        //  62 : Visualisation mode détail recherche
        AvailableSrcTabDetail.forEach(item => {
            this.availableSrcTabDetail.push({ label: this.translate.instant(item.value), value: item.value});            
        });

        this.statOldDocBool = true;
        this.lastReqBool = true;
        this.statLoadBool = true;
        this.statViewBool = true;
        this.statWorkBool = true;
        this.bskCompactBool = false;     
    }

    // Initialisation du tableau avec toutes les valeurs par défaut
    // Attention : modifier la partie server
    //  0 : Ecran par défaut
    //  1 : Thème des composants
    //  2 : Cacher le bannettes vides
    //  3 : Thème du menu
    //  4 : Style du menu
    //  5 : Gradient des bannettes
    //  6 : Afficher nombre de document intégrés
    //  7 : Style du diagramme
    //  8 : Période stat intégration
    //  9 : Bannettes chargées à afficher
    //  10 à 19 pour le dashboard
    //  20 : Document suivant après validation
    //  21 : Thème de la bannière
    //  22 : Taille de l'affichage
    //  23 : Taille maxi envoi fichier
    //  24 : Nombre de requêtes à afficher
    //  25 : Durée du token
    //  26 : Mode de visualisation
    //  27 : Accès aux préférences
    //  28 : Titre menu écrans personnalisés
    //  29 : Afficher les anciens documents
    //  30 : Afficher les dernières requêtes
    //  31 : Afficher les bannettes chargées
    //  32 : Afficher les documents consultés
    //  33 : Afficher les documents traités
    //  34 : Sélection image de fond
    //  35 : Sélection logo
    //  36 : Couleur bannette mail
    //  37 : Couleur bannette collect
    //  38 : Couleur bannette publish
    //  39 : Couleur bannette action
    //  40 : Couleur bannette input
    //  41 : Couleur bannette output
    //  42 : Couleur bannette system
    //  43 : Mode visu document
    //  44 : Date par défaut recherche plein texte
    //  45 : Type d'affichage des input primeng
    //  46 : Activation mentions
    //  47 : Recalcul des positions des docks
    //  48 : SMTP host
    //  49 : SMTP port
    //  50 : SMTP user
    //  51 : SMTP pass
    //  52 : SMTP from
    //  53 : SMTP auth
    //  54 : Bannette mode compacte
    //  55 : Extensions bannettes
    //  56 : Déconnexion azure
    //  57 : Durée toast
    //  58 : Afficher les fenêtres de confirmation
    //  59 : Afficher les recherches par type    
    //  60 : SMTP encryption
    //  61 : Visualisation mode détail bannette
    //  62 : Visualisation mode détail recherche
    //  63 : Réorganisation des docks des bannettes
    //  64 : Réorganisation des docks des recherches
    //  65 : Ecran par défaut général
    
    private initializeValDef() {
        addRequestParam(this.requests, this.translate.instant('Pref_0'), defaultPage, 0, 0);
        addRequestParam(this.requests, this.translate.instant('Pref_1'), 'blue', 0, 1);
        addRequestParam(this.requests, this.translate.instant('Pref_3'), 'light', 0, 3);
        addRequestParam(this.requests, this.translate.instant('Pref_21'), 'dark', 0, 21);        
        addRequestParam(this.requests, this.translate.instant('Pref_4'), 3, 0, 4);
        addRequestParam(this.requests, this.translate.instant('Pref_22'), 14, 0, 22);        
        addRequestParam(this.requests, this.translate.instant('Pref_2'), 'false', 0, 2);
        addRequestParam(this.requests, this.translate.instant('Pref_5'), 'true', 0, 5);
        addRequestParam(this.requests, this.translate.instant('Pref_9'), defBskLoadMax, 0, 9);
        addRequestParam(this.requests, this.translate.instant('Pref_24'), defReqLoadMax, 0, 24);        
        addRequestParam(this.requests, this.translate.instant('Pref_20'), 'false', 0, 20);
        addRequestParam(this.requests, this.translate.instant('Pref_26'), defaultModeView, 0, 26);
        addRequestParam(this.requests, this.translate.instant('Pref_29'), 'true', 0, 29);
        addRequestParam(this.requests, this.translate.instant('Pref_30'), 'true', 0, 30);
        addRequestParam(this.requests, this.translate.instant('Pref_31'), 'true', 0, 31);
        addRequestParam(this.requests, this.translate.instant('Pref_32'), 'true', 0, 32);
        addRequestParam(this.requests, this.translate.instant('Pref_33'), 'true', 0, 33);
        addRequestParam(this.requests, this.translate.instant('Pref_45'), InputStyle.indexOf(this.layoutService.config().inputStyle), 0, 45);
        addRequestParam(this.requests, this.translate.instant('Pref_54'), 'false', 0, 54);
        addRequestParam(this.requests, this.translate.instant('Pref_61'), defaultModeViewDoc, 0, 61);
        addRequestParam(this.requests, this.translate.instant('Pref_62'), defaultModeViewDoc, 0, 62);
        if (this.isAdmin === true) {
            addRequestParam(this.requests, this.translate.instant('Pref_6'), 'false', 0, 6);
            addRequestParam(this.requests, this.translate.instant('Pref_7'), defStatStyle, 0, 7);
            addRequestParam(this.requests, this.translate.instant('Pref_8'), defStatPer, 0, 8);
            addRequestParam(this.requests, this.translate.instant('Pref_27'), 'true', 0, 27);
        }
    }

    public onInitalize() {
        this.itemConfirm.confirmAction(
            'init',
            this.translate.instant('Confirm_Param'),
            () => {
                this.initialize();
            }
        );
    }

    public onApplyParam() {
        this.itemConfirm.confirmAction(
            'params',
            this.translate.instant('Confirm_Param_A'),
            () => {
                this.applyParam();
            }
        );
    }

    public applyParam() {
        this.applyParamUser();
    }
    
    public initialize() {
        let wRequestList = [];
        let wRequestData: {};        
        this.requests = [];
        this.initializeValDef();
        this.requests.forEach((item) => {
            wRequestData = {
                requestData: setUpdatePref(item.id, item.typepref, item.datapref)
            };
            wRequestList.push(wRequestData);       
        });
        wRequestData = {
            updatelist: wRequestList,
        };
        this.update(wRequestData, true);
    }

    // Maj des valeurs
    // Attention : valeurs utilisées : de 10 à 19 pour le dashboard
    private affectValue(aItem) {
        switch (aItem.typepref) {
            case 0: {
                this.screen = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.defaultPage = getPageFromType(this.screen.datapref);
                break;
            }
            case 1: {
                this.theme = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 2: {
                this.emptyBsk = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.emptyBskBool = convertStringToBoolean(this.emptyBsk.datapref);
                this.internalPrefUsr.emptyBsk = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 3: {
                this.menuTheme = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 4: {
                this.styleMenu = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 5: {
                this.gradBsk = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.gradBskBool = convertStringToBoolean(this.gradBsk.datapref);
                this.internalPrefUsr.gradBsk = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 6: {
                this.statNbDoc = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.statNbDocBool = convertStringToBoolean(this.statNbDoc.datapref);
                break;
            }
            case 7: {
                this.statStyle = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 8: {
                this.statPer = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 9: {
                this.bskLoadMax = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.bskLoadMax = aItem.datapref;
                break;
            }
            case 20: {
                this.bskNextVal = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.bskNextValBool = convertStringToBoolean(this.bskNextVal.datapref);
                this.internalPrefUsr.bskNextVal = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 21: {
                this.topBarTheme = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 22: {
                this.scale = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.appConfig.scale = Number(this.scale.datapref)
                break;
            }
            case 24: {
                this.reqLoadMax = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 26: {
                this.modeView = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.modeView = aItem.datapref;
                break;                
            }
            case 29: {
                this.statOldDoc = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.statOldDocBool = convertStringToBoolean(this.statOldDoc.datapref);
                break;
            }
            case 30: {
                this.lastReq = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.lastReqBool = convertStringToBoolean(this.lastReq.datapref);
                break;
            }
            case 31: {
                this.statLoad = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.statLoadBool = convertStringToBoolean(this.statLoad.datapref);
                break;
            }
            case 32: {
                this.statView = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.statViewBool = convertStringToBoolean(this.statView.datapref);
                break;
            }
            case 33: {
                this.statWork = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.statWorkBool = convertStringToBoolean(this.statWork.datapref);
                break;
            }
            case 43: {
                this.modeViewDoc = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.modeViewDoc = aItem.datapref;
                break;                
            }
            case 44: {
                this.defaultFullTextDate = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.defaultFullTextDate = aItem.datapref;
                break;                
            }
            case 45: {
                this.styleInput = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                break;
            }
            case 54: {
                this.bskCompact = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.bskCompactBool = convertStringToBoolean(this.bskCompact.datapref);
                this.internalPrefUsr.bskCompact = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 61: {
                this.bskTabDetail = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.bskTabDetail = aItem.datapref;
                break;                
            }
            case 62: {
                this.srcTabDetail = updateRequestParam(this.requests, aItem.datapref, aItem.id, aItem.typepref);
                this.internalPrefUsr.srcTabDetail = aItem.datapref;
                break;                
            }
        }
    }

    public getLabelOfTypePref(aTypePref, ) {
        return getLabelOfTypePref(aTypePref, this.requests);
    }

    public ChangeTheme($event) {
        this.menu.changeTheme($event.value);
        this.saveValue(1);
    }

    public onChangeTheme(theme: any) {
        theme = theme.value;
        const themeLink = <HTMLLinkElement>document.getElementById('theme-link');
        const newHref = themeLink.getAttribute('href')!.replace(this.layoutService.config().componentTheme, theme);
        this.layoutService.replaceThemeLink(newHref);
        this.layoutService.config().componentTheme = theme;
        this.layoutService.onConfigUpdate();
        this.saveValue(1);
    }

    public onChangeMenuTheme($event) {
        this.layoutService.config().menuTheme = $event.value;
        this.saveValue(3);
    }

    public onChangeTopBarTheme($event) {
        this.layoutService.config().topbarTheme = $event.value;
        this.saveValue(21);
    }

    public onChangeInputStyle($event: any) {
        this.layoutService.config().inputStyle = InputStyle[$event.value];
        this.saveValue(45);
    }
    
    public onChangeValue($event) {
        this.saveValue($event);
    }

    public onChangeMenu($event) {
        this.layoutService.config().menuMode = <MenuMode>MenuStyle[$event.value];
        this.saveValue(4);
    }

    private resetDefValue() {
        this.layoutService.config().scale = 14;
        this.menu.changeScale(this.layoutService.config().scale);
        this.layoutService.config().topbarTheme = 'dark';
        this.layoutService.config().menuMode = 'horizontal';
        this.layoutService.config().menuTheme = 'light';
        this.layoutService.config().inputStyle = 'filled';
        this.layoutService.config().colorScheme = 'light';
        this.layoutService.config().componentTheme = 'blue';
    }

    public saveValue(aValue) {
        this.update(this.prepareRequestData(aValue), false);
    }
    
    private async update(aData, aInitialize) {
        let wRes;
        wRes = false;
        const wData = {
            requestData: aData,
            initialize: aInitialize,
        };
        wRes = await this.requestTools.setUserPref(wData);
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        this._messageService.addInfo(this.translate.instant('Update_OK'));
        if (aInitialize === false) {
            this.affectValue(wRes.data.data.requestData);
            this.storeLocal(wRes.data.data.requestData);
            storeData('internalprefusr', btoa(JSON.stringify(this.internalPrefUsr)));
        } else {
            this.resetDefValue();
            await this.execGetPref(false);
        }
    }
    
    private async applyParamUser() {
        let wRes;
        wRes = false;
        wRes = await this.requestTools.setAllUserPref();
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        this._messageService.addInfo(this.translate.instant('Update_OK'));
    }

    private storeLocal(aData) {
        if (aData.typepref === 1) {
            this.currentPref.theme = aData.datapref;
            storeData('preference', JSON.stringify(this.currentPref));
        }        
        if (aData.typepref === 3) {
            this.currentPref.menuTheme = aData.datapref;
            storeData('preference', JSON.stringify(this.currentPref));
        }
        if (aData.typepref === 4) {
            this.currentPref.menuStyle = aData.datapref;
            storeData('preference', JSON.stringify(this.currentPref));
        }
        if (aData.typepref === 21) {
            this.currentPref.topBarTheme = aData.datapref;
            storeData('preference', JSON.stringify(this.currentPref));
        }
        if (aData.typepref === 22) {
            this.currentPref.scale = aData.datapref;
            storeData('preference', JSON.stringify(this.currentPref));
        }
    }

    // Attention : valeurs utilisées : de 10 à 19 pour le dashboard
    private prepareRequestData(aType) {
        let requestData: {};
        var fn;
        const type = {
            0: [this.screen.id, 0, this.screen.datapref],
            1: [this.theme.id, 1, this.theme.datapref],
            2: [this.emptyBsk.id, 2, this.emptyBskBool.toString()],
            3: [this.menuTheme.id, 3, this.menuTheme.datapref],
            4: [this.styleMenu.id, 4, this.styleMenu.datapref],
            5: [this.gradBsk.id, 5, this.gradBskBool.toString()],
            6: [this.statNbDoc.id, 6, this.statNbDocBool.toString()],
            7: [this.statStyle.id, 7, this.statStyle.datapref],
            8: [this.statPer.id, 8, this.statPer.datapref],
            9: [this.bskLoadMax.id, 9, this.bskLoadMax.datapref],
            20: [this.bskNextVal.id, 20, this.bskNextValBool.toString()],
            21: [this.topBarTheme.id, 21, this.topBarTheme.datapref],
            22: [this.scale.id, 22, this.scale.datapref],
            24: [this.reqLoadMax.id, 24, this.reqLoadMax.datapref],
            26: [this.modeView.id, 26, this.modeView.datapref],
            29: [this.statOldDoc.id, 29, this.statOldDocBool.toString()],
            30: [this.lastReq.id, 30, this.lastReqBool.toString()],
            31: [this.statLoad.id, 31, this.statLoadBool.toString()],
            32: [this.statView.id, 32, this.statViewBool.toString()],
            33: [this.statWork.id, 33, this.statWorkBool.toString()],
            45: [this.styleInput.id, 45, this.styleInput.datapref],
            54: [this.bskCompact.id, 54, this.bskCompactBool.toString()],
            61: [this.bskTabDetail.id, 61, this.bskTabDetail.datapref],
            62: [this.srcTabDetail.id, 62, this.srcTabDetail.datapref],
        }
        if (type[aType]) {
            fn = type[aType];
            return requestData = setUpdatePref(fn[0], fn[1], fn[2]);
        }
    }
}
